export default "__VITE_ASSET__BVqgmlf5__"